document.addEventListener("DOMContentLoaded", () => {

  const buttons = document.querySelectorAll(".crop-btn");
  const panels = document.querySelectorAll(".crop-panel");

  buttons.forEach(button => {

    button.addEventListener("click", () => {

      const target = button.dataset.crop;

      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");

      panels.forEach(panel => {

        if (panel.id === target) {
          panel.classList.remove("hidden");
        } else {
          panel.classList.add("hidden");
        }

      });

    });

  });

});